import React, { useState } from 'react';

const StockAdjustmentModal = ({ product, onSave, onCancel, apiError }) => {
  const [newQuantity, setNewQuantity] = useState(product.stock || 0);
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!reason.trim()) {
      setError('A reason for the adjustment is required.');
      return;
    }
    if (isNaN(newQuantity) || newQuantity < 0) {
        setError('Please enter a valid, non-negative quantity.');
        return;
    }
    onSave({ newQuantity: Number(newQuantity), reason });
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center p-4">
      <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md">
        <h2 className="text-2xl font-bold mb-2">Adjust Stock</h2>
        <p className="text-gray-600 mb-4">Product: <span className="font-semibold">{product.name}</span> (Current: {product.stock})</p>
        {(apiError || error) && (
          <p className="bg-red-100 text-red-700 p-3 rounded mb-4">{apiError || error}</p>
        )}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="newQuantity" className="block text-sm font-medium text-gray-700">New Total Stock Quantity</label>
            <input id="newQuantity" type="number" value={newQuantity} onChange={(e) => setNewQuantity(e.target.value)} className="mt-1 p-2 border rounded-md w-full" required />
          </div>
          <div>
            <label htmlFor="reason" className="block text-sm font-medium text-gray-700">Reason for Adjustment</label>
            <input id="reason" type="text" value={reason} onChange={(e) => setReason(e.target.value)} placeholder="e.g., Stocktake correction, Damaged goods" className="mt-1 p-2 border rounded-md w-full" required />
          </div>
          <div className="flex justify-end space-x-3 pt-4">
            <button type="button" onClick={onCancel} className="bg-gray-200 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-300">Cancel</button>
            <button type="submit" className="bg-primary text-white px-4 py-2 rounded-md hover:bg-primary-dark">Save Adjustment</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default StockAdjustmentModal;
